import { Spinner } from '@7shifts/sous-chef';
import LeadsInAutomationPage from 'modules/Reports/pages/LeadsInAutomationPage';
import LeadsPerDayPage from 'modules/Reports/pages/LeadsPerDayPage';
import LeadsContactsPerDayPage from 'modules/Reports/pages/LeadsContactsPerDayPage';
import { lazy, Suspense } from 'react';
import ErrorBoundary from 'sharedComponents/ErrorBoundary';
import LeadsAwaitingPage from './pages/LeadsAwaitingPage';
import UsersAnalyticPage from './pages/UsersAnalyticPage';
import UsersSyntethicPage from './pages/UsersSyntheticPage';
import TicketsClosedReasonsPage from './pages/TicketsClosedReasonsPage';
import TemplateErrorReportPage from './pages/TemplateErrorReportPage';
import LeadsAwaitingWorkingPage from './pages/LeadsAwaitingWorkingPage';
import ContactsWithoutTicketPage from './pages/ContactsWithoutTicketPage';
import TicketsWithMessagesPage from './pages/TicketsWithMessagesPage';

const ReportsPage = lazy(() => import('./pages/ReportsPage'));
const AuditPage = lazy(() => import('./pages/AuditPage'));

export const ROUTES = [
    {
        path: '/reports',
        element: (
            <Suspense fallback={<Spinner block />}>
                <ReportsPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    },
    {
        path: '/reports/leads-per-day',
        element: (
            <Suspense fallback={<Spinner block />}>
                <LeadsPerDayPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    },
    {
        path: '/reports/leads-contacts-per-day',
        element: (
            <Suspense fallback={<Spinner block />}>
                <LeadsContactsPerDayPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    },
    {
        path: '/reports/leads-in-automation',
        element: (
            <Suspense fallback={<Spinner block />}>
                <LeadsInAutomationPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    },
    {
        path: '/reports/leads-awaiting',
        element: (
            <Suspense fallback={<Spinner block />}>
                <LeadsAwaitingPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    },
    {
        path: '/reports/leads-awaiting-working',
        element: (
            <Suspense fallback={<Spinner block />}>
                <LeadsAwaitingWorkingPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    },
    {
        path: '/reports/users-analytics',
        element: (
            <Suspense fallback={<Spinner block />}>
                <UsersAnalyticPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    },
    {
        path: '/reports/users-synthetic',
        element: (
            <Suspense fallback={<Spinner block />}>
                <UsersSyntethicPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    },
    {
        path: '/reports/ticket-closed-reasons',
        element: (
            <Suspense fallback={<Spinner block />}>
                <TicketsClosedReasonsPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    },
    {
        path: '/reports/contacts-without-ticket',
        element: (
            <Suspense fallback={<Spinner block />}>
                <ContactsWithoutTicketPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    },
    {
        path: '/reports/tickets-with-messages',
        element: (
            <Suspense fallback={<Spinner block />}>
                <TicketsWithMessagesPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    },
    {
        path: '/reports/template-error-report',
        element: (
            <Suspense fallback={<Spinner block />}>
                <TemplateErrorReportPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    },
    {
        path: '/reports/audit',
        element: (
            <Suspense fallback={<Spinner block />}>
                <AuditPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    }
];
